import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import SuperAdminAdd from "../screens/masters/superAdmin/superAdminAdd";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/super-admin-list", name: "Super Admin List" },
  { name: "Super Admin Add" },
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <SuperAdminAdd />
    </LayoutContainer>
  </>
);

export default Home;
